import { take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { getProfileSlump } from '../../../selectors/single-catalogs';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { CmxClientService } from '@cemex/cmx-client-layout';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class SetProjectProfileSlumpCommand implements OnFieldChanged {
  constructor(
    private store: Store<OrderBuilderState>,
    private alertService: CmxClientService,
    private translate: TranslateService,
  ) {}

  onFieldChanged(value: number, formGroup: UntypedFormGroup): void {
    if (value) {
      this.store
        .select(getProfileSlump)
        .pipe(take(1))
        .subscribe((data) => {
          const slumpFromProfile = _safe(
            () =>
              data.profiles.projectProfiles.find((profile) => profile.profileId === Number(value)).project
                .projectProperties.slump,
          );
          const productCode = formGroup.get(SpecFieldNames.PRODUCT_SELECTION).value;
          const slumps = data.slumps[productCode];
          if (!!value) {
            const slumpProfile = Number(slumpFromProfile);
            const targetSlump = _safe(() => slumps.slumpProduct.targetSlump);
            const lowSlump = _safe(() => slumps.slumpProduct.slumpLow);
            const highSlump = _safe(() => slumps.slumpProduct.slumpHigh);
            const slumpProfilePartOfTheOptions = _safe(() =>
              slumps.slumps.find((item) => item.slumpCode === slumpProfile.toString()),
            );
            if (!!targetSlump && !slumpProfilePartOfTheOptions) {
              this.handleMessages(slumpFromProfile, targetSlump, lowSlump, highSlump);
              const slumpCode =
                _safe(() => slumps.slumpProduct.targetSlump) > 0
                  ? slumps.slumpProduct.targetSlump.toString()
                  : slumps.slumpProduct.slumpLow.toString();
              formGroup.get(SpecFieldNames.SLUMP_PRODUCT).patchValue(slumpCode);
            } else if (!targetSlump && !slumpProfilePartOfTheOptions) {
              this.handleMessages(slumpFromProfile, targetSlump, lowSlump, highSlump);
              const slumpCode = slumps.slumpProduct.slumpLow.toString();
              formGroup.get(SpecFieldNames.SLUMP_PRODUCT).patchValue(slumpCode);
            } else {
              this.handleMessages(slumpFromProfile, targetSlump, lowSlump, highSlump);
              const slumpFromProfileString = slumpProfile.toString();
              formGroup.get(SpecFieldNames.SLUMP_PRODUCT).patchValue(slumpFromProfileString);
            }
          }
        });
    }
  }

  private handleMessages(profile: number, target: number, low: number, high: number) {
    if (profile < low) {
      this.alertService.closeAllAlerts();
      this.alertService.addMainAlert(
        'warning',
        this.translate.instant('views.common.slump_profile_low').replace('&', low),
      );
    } else if (profile > high) {
      this.alertService.closeAllAlerts();
      this.alertService.addMainAlert(
        'warning',
        this.translate.instant('views.common.slump_profile_high').replace('&', high),
      );
    } else if (profile !== target) {
      this.alertService.closeAllAlerts();
      this.alertService.addMainAlert('warning', this.translate.instant('views.common.slump_profile_error'));
    }
  }
}
